module.exports = __webpack_public_path__ + "static/media/background.9e735641.jpeg";